(function() {
    var memberMain = {
        setting: function() {
            var self = this;
            self.$content = $('.contents.membership-tabs');
            self.$tabContent = self.$content.find('.tab-contents');
            self.$tab = self.$content.find('.page-tabs .ui_stickyTab');
            
            self.isLogin = lgkorUI.stringToBool(self.$content.data('loginflag'));
            self.loginUrl = self.$content.data('loginUrl');
            self.isMembership = lgkorUI.stringToBool(self.$content.data('mebershipflag'));
            self.newbestDowntimeFlag = lgkorUI.stringToBool(self.$content.data('newbestdowntimeflag')); // BTOCSITE-78031
            self.$cardInfoPopup = $('#membershipPopup');
        },
        init: function() {
            var self = this;
            self.UI.init(self);
            self.API.init(self);
        }
        // BTOCSITE-103683 웹접근성
        ,binds: function(){
        	$("#anc_membershipShop").on("click",function(){
        		$("#membershipShop").focus();
        	});

            var self = this;

            //카테고리탭
            self.$content.on('click', '.app-membership-btn', function(e){
                e.preventDefault();
                self.$cardInfoPopup.vcModal({opener:$(this)});
            });
        }
    }

    // S : BTOCSITE-24808
    document.addEventListener('DOMContentLoaded', function () {
        var self = memberMain;
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        self.setting();
        if (location.hash) {
            self.$tab.find('li').removeClass('on').find('[href="'+location.hash+'"]').parent('li').addClass('on');
            self.$tabContent.hide().filter(location.hash).show();
        }
    });
    // E : BTOCSITE-24808

    $(window).ready(function () {
        if (!document.querySelector('.contents.membership-tabs')) return false;
        $('.contents.membership-tabs').buildCommonUI();
        vcui.require(['membership/modules/main.ui', 'membership/modules/main.api'], function (mainUi, mainApi) {
            var self = memberMain;
            self.UI = mainUi;
            self.API = mainApi;
            self.init();
            // BTOCSITE-103683 웹접근성
            self.binds();
        });
    })
})();